'use strict';

var _defineProperty = require("/home/runner/work/neoswap-app-react/neoswap-app-react/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});

/** @category Errors */
class DeserializingEmptyBufferError extends Error {
  constructor(serializer) {
    super(`Serializer [${serializer}] cannot deserialize empty buffers.`);
    _defineProperty(this, "name", 'DeserializingEmptyBufferError');
  }
}

/** @category Errors */
class NotEnoughBytesError extends Error {
  constructor(serializer, expected, actual) {
    super(`Serializer [${serializer}] expected ${expected} bytes, got ${actual}.`);
    _defineProperty(this, "name", 'NotEnoughBytesError');
  }
}

/** @category Errors */
class ExpectedFixedSizeSerializerError extends Error {
  constructor(message) {
    var _message;
    (_message = message) !== null && _message !== void 0 ? _message : message = 'Expected a fixed-size serializer, got a variable-size one.';
    super(message);
    _defineProperty(this, "name", 'ExpectedFixedSizeSerializerError');
  }
}
exports.DeserializingEmptyBufferError = DeserializingEmptyBufferError;
exports.ExpectedFixedSizeSerializerError = ExpectedFixedSizeSerializerError;
exports.NotEnoughBytesError = NotEnoughBytesError;
//# sourceMappingURL=errors.cjs.map